import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const ProspectActivityEmailFailedColored = () => (
  <ImageIcon
    src={Images.ProspectActivityEmailFailedColored}
    alt="empty-data/"
  />
);

export default ProspectActivityEmailFailedColored;
